import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromApp from '../../../app.reducer';
import * as newActions from '../../new/store/new.actions';

@Component({
  selector: 'hires-warning-message',
  styleUrls: ['./hires-warning-meassage.component.scss'],
  templateUrl: './hires-warning-meassage.component.html',
})
export class HiresWarningMeassageComponent implements OnInit {
  closed;
  mouseLeaved;

  constructor(
    private store: Store<fromApp.AppState>
  ) {}

  ngOnInit() {
    this.store.select('new').subscribe(store => {
      this.closed = store.warningMessageClosed;
      this.mouseLeaved = store.mouseLeaved;
    });
  }

  close() {
    this.store.dispatch(new newActions.WarningMessageClosed());
  }
}
